import React, { useContext, useMemo, useRef, useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { Cases, DELETE_CONFIRM, modalsName } from "../../../constant";
import ByteCardBuilderContext from "../../../context/BytecardBilderContext/ByteCardBuilderContext";
import { OpenModalCommonFunc, TostMessage } from "../../../utils";
import CardBuilderHeaderSection from "../../../common/cardBuilderHeaderSection";
import CommonPopup from "../../../Modals/commonPopup";
import ImagesMultipagePopup from "./ImagesMultipagePopup";
import EditIcon from "@mui/icons-material/Edit";
import {
  deleteImagesParent,
  getImages,
  getImagesDetails,
  getImagesParent,
  getImagesParentDetails,
  postImages,
  postImagesParent,
  putUpdateImages,
  putUpdateImagesParent,
  updateStatus,
  updateStatusImages,
} from "../apis/ImageApi/ImageApi";
import ImagesMultipageParentPopup from "./ImagesMultipageParentPopup";
import { FILE_UPLOAD_API } from "../apis/SliderApi/SliderApi";
import {
  generateDynamicStyles,
  generateDynamicStylesSet,
  isCheckValue,
  isEmptyObject,
  randomStr,
  rgbColorCreate,
} from "../../../../utils/helper";
import { FILE_TYPE, ThemeNo, titleUpdateKey } from "../../../../constant";
import { IconButton } from "@material-ui/core";
import { Settings, Trash } from "react-feather";
import LoaderContext from "../../../../context/LoaderContext/LoaderContext";
import SimpleReactValidator from "simple-react-validator";
import SettingImageParentPopup from "./SettingImagesPerentPopup";
import GalleryMultipageContext from "../../../context/GalleryMultipageContext/GalleryMultipageContext";
import ChildShow from "./ChildShow";
import { Boy } from "@mui/icons-material";
import {
  ThemeOneStyleSet,
  ThemeTwoStyleSet,
  imagesGalleryThemeOneReset,
  imagesGalleryThemeTwoReset,
  themeOneFunction,
  themeTwoFunction,
} from "./ImagesStyleThemeFunctions";
import DeleteSection from "../../../common/DeleteSection";
import SettingMultiWebContext from "../../../../context/SettingMultiWebContext/SettingMultiWebContext";
import { uploadFileToSpaces } from "../../../apis/dashboardAPi/DeshboardApi";

const ImagesMultipage = (props) => {
  const {
    pageConfigDetails,
    webMasterDetail,
    getData,
    contentMapId,
    galleryDetail,
    ByteMiniWeb_Dashboard,
    navMapId: navMapIds,
    contentDetail,
  } = props;
  const { allPopupState, setAllPopupState } = useContext(
    ByteCardBuilderContext
  );
  const { setCloneAlignModal, setAlignFormData, setCloneFormData } = useContext(
    SettingMultiWebContext
  );
  const parentValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();
  const childValidator = useRef(new SimpleReactValidator());
  const simpleValidator = useRef(new SimpleReactValidator());
  const simpleValidatorImages = useRef(new SimpleReactValidator());
  const [, forceUpdate1] = useState();
  const {
    apiData: imagesData,
    setApiData,
    fromData,
    setFormData,
    formDataImageParent,
    setFormDataImageParent,
    id,
    setId,
    setIsEdit,
    isEdit,
    filter,
    apiDataOurTeam: apiDataImageParent,
    setApiDataOurTeam: setApiDataImageParent,
    setSkill,
    galleryImgId,
    setGalleryImgId,
    setSettingFormData,
    settingFormData,
    setParentData,
    setBackImageToggle,
    boxSection,
    setBoxSection,
    collId,
    setCollId,
    theme,
    setTheme,
    isChildForFormSubmit,
    setIsChildForFormSubmit,
    isBackgroundColor,
    setIsBackgroundColor,
    setIsImageParent,
    ids,
    setIds,
    imgShow,
    setImgShow,
    childId,
    setChildId,
    sectionPageName,
    setSectionPageName,
  } = useContext(GalleryMultipageContext);
  const { setLoaderShow } = useContext(LoaderContext);

  const [childData, setChildData] = useState([]);
  const [isBack, setIsBack] = useState([]);
  const [idCopy, setIdCopy] = useState("");
  const [CountUp, setCountUp] = useState(0);
  /**
   * get images list
   */
  const getImagesList = async (status) => {
    try {
      if (!filter.length && status) {
        setApiData((prev) => {
          return { ...prev, isLoading: true };
        });
      }
      let paramObj = {
        search: { galleryId: id, contentMapId: collId },
        galleryId: id,
        showAll: true,
      };
      if (filter.length) {
        delete paramObj.showAll;
        paramObj.search = { ...paramObj.search, title: filter };
      }
      const { data } = await getImages(paramObj);
      if (data.status === 200) {
        setApiData({
          ...imagesData,
          isLoading: false,
          data: data.payload.data.map((elem) => {
            return {
              id: elem?.title + elem?.galleryImgId,
              Id: elem?.galleryImgId,
              name: elem?.title,
              image: elem?.path,
              isDefault: elem?.isDefault,
              webId: elem?.webId,
              createdAt: elem?.createdAt,
              isActive: elem?.isActive,
              parentId: elem?.parentId,
            };
          }),
        });
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
    }
  };

  /**
   * get our team list
   * @param {status} status
   */
  const getImagesParentList = async ({
    status,
    isEditImageParent,
    id,
    prev,
    isChild,
  }) => {
    try {
      if (!filter.length && status) {
        setApiDataImageParent((prev) => {
          return { ...prev, isLoading: true };
        });
      }
      let paramObj = {
        showAll: true,
      };
      if (isChild) {
        if (prev === "prev") {
          if (isCheckValue({ value: id })) {
            paramObj["search"] = { parentId: ids[id] };
            let obj = { ...ids };
            if (ids[id]) {
              delete obj[id];
            }
            setIds(obj);
          }
        } else {
          paramObj["search"] = { parentId: id || idCopy || childId || null };
        }
      } else {
        paramObj = {
          ...paramObj,
          search: { parentId: null, contentMapId },
        };
      }
      const { data } = await getImagesParent(paramObj);
      if (data.status === 200) {
        if (isChild) {
          if (data.payload.data.length <= 0) {
            setIsBack([...childData]);
          } else {
            setIsBack([]);
          }
          setChildData(data.payload.data);
        } else if (
          isEditImageParent !== null &&
          isEditImageParent !== false &&
          typeof isEditImageParent === "boolean" &&
          isEditImageParent !== undefined
        ) {
          setParentData([
            {
              parent: data.payload.data,
              parentId: "",
            },
          ]);
          return data.payload.data;
        } else {
          setApiDataImageParent({
            ...apiDataImageParent,
            isLoading: false,
            data: data.payload.data,
          });
        }
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
    }
  };
  useMemo(() => {
    if (allPopupState.imagesPopup) {
      getImagesList();
    }
  }, [filter, allPopupState?.imagesPopup]);

  /**
   * images enable disable api call
   * @param {galleryImg id} galleryImgId
   * @param {status} isActive
   */

  const handleChangeStatus = async (
    galleryImgId,
    isActive,
    isChild,
    parentId
  ) => {
    try {
      let body = {
        galleryImgId,
        isActive: isActive ? false : true,
        parentId,
      };
      const { data } = await updateStatusImages(body);
      if (data.status === 200) {
        if (isChild) {
          getImagesList(false);
        } else {
          ByteMiniWeb_Dashboard();
        }
        TostMessage({ message: data, type: "success" });
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
    }
  };
  /**
   * images parent enable disable api call
   * @param {gallery id} galleryId
   * @param {status} isActive
   */

  const handleChangeImageParent = async (
    galleryId,
    isActive,
    isChild,
    parentId
  ) => {
    try {
      let body = {
        galleryId,
        isActive: isActive ? false : true,
        parentId,
      };
      const { data } = await updateStatus(body);
      if (data.status === 200) {
        if (isChild) {
          getImagesParentList({ isChild });
        } else {
          ByteMiniWeb_Dashboard();
        }
        TostMessage({ message: data, type: "success" });
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
    }
  };

  /**
   * file upload
   * @param {file} file
   */
  const imageUploadImages = async (file) => {
    // let formData = new FormData();
    // formData.append("type", FILE_TYPE.GALLERY_IS);
    // formData.append("file", file);
    setLoaderShow(true);
    const uniqueName = `${Date.now()}-${file.name}`;
    const formData = {
      type: FILE_TYPE.GALLERY_IS,
      file: uniqueName,
      fileType: file.type,
    };
    try {
      const { data } = await FILE_UPLOAD_API(formData);
      if (data.status === 200) {
        if (!data.payload?.uploadUrl) {
          TostMessage({ message: "Failed to get upload URL", type: "error" });
          setLoaderShow(false);
          return;
        }
        await uploadFileToSpaces(data.payload.uploadUrl, file);
        setSettingFormData((prev) => {
          if (theme === 1) {
            return {
              ...prev,
              ".photo-gallery-section.bg-image": {
                "background-image":
                  data.payload.baseUrl + data.payload.imageUrl,
              },
            };
          } else if (theme === 3) {
            return {
              ...prev,
              ".photo-gallery-section.bg-image": {
                "background-image":
                  data.payload.baseUrl + data.payload.imageUrl,
              },
            };
          } else if (theme === 2 || theme === 4) {
            return {
              ...prev,
              ".certificates-section.bg-image": {
                "background-image":
                  data.payload.baseUrl + data.payload.imageUrl,
              },
            };
          }
        });
        setLoaderShow(false);
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
      setLoaderShow(false);
    }
  };

  const imageUploadImagess = async (file) => {
    // let formData = new FormData();
    // formData.append("type", FILE_TYPE.GALLERY_IS);
    // formData.append("file", file);
    setLoaderShow(true);
    const uniqueName = `${Date.now()}-${file.name}`;
    const formData = {
      type: FILE_TYPE.GALLERY_IS,
      file: uniqueName,
      fileType: file.type,
    };
    try {
      const { data } = await FILE_UPLOAD_API(formData);
      if (data.status === 200) {
        if (!data.payload?.uploadUrl) {
          TostMessage({ message: "Failed to get upload URL", type: "error" });
          setLoaderShow(false);
          return;
        }
        await uploadFileToSpaces(data.payload.uploadUrl, file);
        setFormData((prev) => {
          return {
            ...prev,
            image: data.payload.baseUrl + data.payload.imageUrl,
          };
        });
        setLoaderShow(false);
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
      setLoaderShow(false);
    }
  };

  /**
   * create and update images items
   */
  const handleSubmit = async () => {
    const formValid = simpleValidatorImages.current.allValid();
    if (!formValid) {
      simpleValidatorImages.current.showMessages();
      forceUpdate1(1);
    } else {
      if (galleryImgId >= -1 && isEdit) {
        setLoaderShow(true);
        let newData = {};
        if (fromData.image.length) {
          setFormData((prev) => {
            return {
              ...prev,
              path: prev.image
                .split(`${process.env.REACT_APP_BUCKET_PRO_FOLDER_MULTI}/`)
                .pop(),
              isDefault: true,
              galleryId: id,
              galleryImgId: galleryImgId,
              contentMapId: collId,
            };
          });
          newData = {
            ...fromData,
            path: fromData.image
              .split(`${process.env.REACT_APP_BUCKET_PRO_FOLDER_MULTI}/`)
              .pop(),
            isDefault: true,
            galleryId: id,
            galleryImgId: galleryImgId,
            contentMapId: collId,
          };
          delete newData.image;
        } else {
          newData = {
            ...fromData,
            galleryId: id,
            galleryImgId: galleryImgId,
            contentMapId: collId,
          };
        }
        try {
          const { data } = await putUpdateImages(newData);
          if (data.status === 200) {
            getImagesList();
            emptyData();
            TostMessage({ message: data, type: "success" });
          }
        } catch (error) {
          TostMessage({ message: error, type: "error" });
          setLoaderShow(false);
        }
      } else {
        try {
          setLoaderShow(true);
          let newData = {};
          if (fromData.image.length) {
            setFormData((prev) => {
              return {
                ...prev,
                path: prev.image
                  .split(`${process.env.REACT_APP_BUCKET_PRO_FOLDER_MULTI}/`)
                  .pop(),
                isDefault: true,
                galleryId: id,
                order: imagesData.data.length + 1,
                contentMapId: collId,
              };
            });
            newData = {
              ...fromData,
              path: fromData.image
                .split(`${process.env.REACT_APP_BUCKET_PRO_FOLDER_MULTI}/`)
                .pop(),
              galleryId: id,
              isDefault: true,
              order: imagesData.data.length + 1,
              contentMapId: collId,
            };
            delete newData.image;
          } else {
            newData = {
              ...fromData,
              galleryId: id,
              order: imagesData.data.length + 1,
              contentMapId: collId,
            };
          }
          const { data } = await postImages(newData);
          if (data.status === 200) {
            getImagesList();
            emptyData();
            TostMessage({ message: data, type: "success" });
          }
        } catch (error) {
          TostMessage({ message: error, type: "error" });
          setLoaderShow(false);
        }
      }
      simpleValidatorImages.current.hideMessages();
      forceUpdate1(2);
    }
  };

  /**
   * create and update images
   */
  const submitForm = async () => {
    if (id >= -1 && isEdit) {
      try {
        setLoaderShow(true);
        let formData = {
          ...formDataImageParent,
          // contentMapId,
          navMapId: +navMapIds,
        };
        if (isCheckValue({ value: formData?.parentId })) {
          delete formData?.style;
        }
        const { data } = await putUpdateImagesParent(formData);
        if (data.status === 200) {
          if (isChildForFormSubmit) {
            getImagesParentList({ isChild: isChildForFormSubmit });
          }
          setId("");
          emptyData();
          OpenModalCommonFunc(Cases.IMAGES_PARENT, setAllPopupState, false);
          TostMessage({ message: data, type: "success" });
          ByteMiniWeb_Dashboard();
        }
      } catch (error) {
        TostMessage({ message: error, type: "error" });
        setLoaderShow(false);
      }
    } else {
      try {
        setLoaderShow(true);
        let formData = {
          ...formDataImageParent,
          contentMapId: collId,
          navMapId: +navMapIds,
        };
        if (isCheckValue({ value: formData?.parentId })) {
          delete formData?.style;
        }
        const { data } = await postImagesParent(formData);
        if (data.status === 200) {
          if (isChildForFormSubmit) {
            getImagesParentList({ isChild: isChildForFormSubmit });
          }
          emptyData();
          OpenModalCommonFunc(Cases.IMAGES_PARENT, setAllPopupState, false);
          TostMessage({ message: data, type: "success" });
          ByteMiniWeb_Dashboard();
        }
      } catch (error) {
        TostMessage({ message: error, type: "error" });
        setLoaderShow(false);
      }
    }
  };
  const handleSubmitImages = async (formValidationCondition) => {
    let validatorFields;
    if (formValidationCondition === "parentForm") {
      validatorFields = parentValidator.current;
    } else if (formValidationCondition === "childForm") {
      validatorFields = childValidator.current;
    }
    validatorFields.showMessages();

    if (validatorFields.allValid()) {
      try {
        // Process form data based on the formType
        if (formValidationCondition === "parentForm") {
          submitForm();
        } else if (formValidationCondition === "childForm") {
          submitForm();
        }
        validatorFields.hideMessages();
      } catch (error) {
        // Handle error for form submission
      }
    } else {
      // Force update to display validation messages
      forceUpdate({});
    }
  };

  /**
   * create and update images
   */
  const handleSubmitSetting = async (isRestore = false, isClose = true) => {
    if (id >= -1 && isEdit) {
      setLoaderShow(true);
      try {
        let newData;
        if (isRestore) {
          const isConfirm = window.confirm(
            "Are you sure want to restore style ?"
          );
          if (isConfirm) {
            newData = {
              styleRestore: true,
              galleryId: id,
              contentMapId: collId,
            };
          } else {
            setLoaderShow(false);
            return;
          }
        } else {
          setIsChildForFormSubmit(true);
          if (+theme === ThemeNo.ThemeOne) {
            newData = themeOneFunction({ settingFormData, boxSection });
            const menuBtnStyle = generateDynamicStyles(
              settingFormData,
              ".photo-gallery-section"
            );
            newData = { ...newData, ...menuBtnStyle };
            if (isBackgroundColor) {
              newData[".photo-gallery-section"] = {
                ...newData?.[".photo-gallery-section"],
                "background-color": settingFormData[".photo-gallery-section"]?.[
                  "background-color"
                ]
                  ? rgbColorCreate({
                    rgbString:
                      settingFormData[".photo-gallery-section"]?.[
                      "background-color"
                      ],
                  })
                  : "",
              };
            }
            if (boxSection) {
              newData[".photo-gallery-section.bg-image::before"] = {
                ...newData[".photo-gallery-section.bg-image::before"],
                "border-radius": `${settingFormData[".photo-gallery-section"][
                  "border-radius"
                ]?.replace("rem", "")}rem`,
              };
            }
          } else if (+theme === ThemeNo.ThemeThree) {
            newData = themeOneFunction({ settingFormData, boxSection });
            const menuBtnStyle = generateDynamicStyles(
              settingFormData,
              ".photo-gallery-section"
            );
            newData = { ...newData, ...menuBtnStyle };
            if (isBackgroundColor) {
              newData[".photo-gallery-section"] = {
                ...newData?.[".photo-gallery-section"],
                "background-color": settingFormData[".photo-gallery-section"]?.[
                  "background-color"
                ]
                  ? rgbColorCreate({
                    rgbString:
                      settingFormData[".photo-gallery-section"]?.[
                      "background-color"
                      ],
                  })
                  : "",
              };
            }
            if (boxSection) {
              newData[".photo-gallery-section.bg-image::before"] = {
                ...newData[".photo-gallery-section.bg-image::before"],
                "border-radius": `${settingFormData[".photo-gallery-section"][
                  "border-radius"
                ]?.replace("rem", "")}rem`,
              };
            }
          } else if (
            +theme === ThemeNo.ThemeTwo ||
            +theme === ThemeNo.ThemeFour
          ) {
            newData = themeTwoFunction({ settingFormData, boxSection });
            const menuBtnStyle = generateDynamicStyles(
              settingFormData,
              ".certificates-section"
            );
            newData = { ...newData, ...menuBtnStyle };
            if (isBackgroundColor) {
              newData[".certificates-section"] = {
                ...newData?.[".certificates-section"],
                "background-color": settingFormData[".certificates-section"]?.[
                  "background-color"
                ]
                  ? rgbColorCreate({
                    rgbString:
                      settingFormData[".certificates-section"]?.[
                      "background-color"
                      ],
                  })
                  : "",
              };
            }
            if (boxSection) {
              newData[".certificates-section.bg-image::before"] = {
                ...newData[".certificates-section.bg-image::before"],
                "border-radius": `${settingFormData[".certificates-section"][
                  "border-radius"
                ]?.replace("rem", "")}rem`,
              };
            }
          }

          const keysToRemove = [
            "bs1",
            "bs2",
            "bs3",
            "bs4",
            "shadowColor",
            "borderPx",
            "borderThik",
            "borderColor",
            "p1",
            "p2",
            "image",
            "parentId",
          ];
          function removeKeys(obj, keys) {
            for (const key in obj) {
              if (typeof obj[key] === "object") {
                removeKeys(obj[key], keys);
              } else if (keys.includes(key)) {
                delete obj[key];
              }
            }
          }

          removeKeys(newData, keysToRemove);
          newData = {
            theme,
            style: newData,
            galleryId: id,
            parentId: newData?.parentId,
            contentMapId: collId,
          };
          delete newData?.parentId;
          delete newData?.style?.parentId;
        }

        const { data } = await putUpdateImagesParent(newData);
        if (data.status === 200) {
          getImagesParentList({});
          if (isClose) {
            emptyData();
            OpenModalCommonFunc(
              Cases.SETTING_IMAGE_MULTI_PAGE_PARENT,
              setAllPopupState,
              false
            );
            setBackImageToggle(false);
          }
          setLoaderShow(false);
          TostMessage({ message: data, type: "success" });
        }
      } catch (error) {
        TostMessage({ message: error, type: "error" });
        setLoaderShow(false);
      }
    }
  };

  /**
   * get images items details
   * @param {id} galleryImgId
   */
  const handleEdit = async (galleryImgId) => {
    try {
      setLoaderShow(true);
      setGalleryImgId(galleryImgId);
      const { data } = await getImagesDetails(galleryImgId);
      if (data.status === 200) {
        let payload = data.payload.data;
        setIsEdit(true);
        setFormData({
          title: payload.title,
          path: payload.path,
          image: payload.path,
          isTitleShow: payload?.isTitleShow ? payload?.isTitleShow : false,
          galleryImgId: payload.galleryImgId,
          isDefault: payload.isDefault,
          webId: localStorage.getItem("webId"),
          link: payload?.link,
          imageAlt: payload.imageAlt || "",
        });
        TostMessage({ message: data, type: "success" });
        setLoaderShow(false);
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
      setLoaderShow(false);
    }
  };

  /**
   * get data images
   * @param {id} galleryId
   */
  const handleEditImagesParent = async (galleryId, isParent) => {
    setIsImageParent(isParent);
    try {
      setLoaderShow(true);
      setId(galleryId);

      const { data } = await getImagesParentDetails(galleryId, navMapIds);
      if (data.status === 200) {
        let payload = data.payload.data;
        setSectionPageName(payload?.title);
        setIsChildForFormSubmit(true);
        let imagesParent = {
          title: payload?.title || "",
          buttonText: payload?.buttonText || "",
          itemLimit: payload?.itemLimit || "",
          navMapId: payload?.navMapId || "",
          description: payload?.description || "",
          subTitle: payload?.subTitle || "",
          theme: payload?.theme || 1,
          isAlbum: payload?.isAlbum || false,
          isTitleShow: payload?.isTitleShow ? payload?.isTitleShow : false,
          slugUrl: payload?.slugUrl || "",
          style: payload?.style || "",
          galleryId: galleryId,
          webId: localStorage.getItem("webId"),
          contentMapId: payload?.contentMapId || "",
        };
        if (payload?.parentId) {
          imagesParent["parentId"] = payload?.parentId;
        }
        setFormDataImageParent({
          ...imagesParent,
        });
        // const response = await getImagesParentList({ isEditImageParent: true });

        OpenModalCommonFunc(Cases.IMAGES_PARENT, setAllPopupState);
        setIsEdit(true);
        TostMessage({ message: data, type: "success" });
        setLoaderShow(false);
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
      setLoaderShow(false);
    }
  };

  /**
   * get setting data
   * @param {id} galleryId
   */
  const handleChangeSettings = async (galleryId, isThemeEdit = false) => {
    try {
      setLoaderShow(true);
      setId(galleryId);
      setSettingFormData((prev) => {
        return {
          ...prev,
          galleryId,
        };
      });
      const { data } = await getImagesParentDetails(galleryId);
      if (data.status === 200) {
        const themeCount = data?.payload?.data?.theme;
        let payload = data.payload.data;
        setSectionPageName(payload?.title);
        setCollId(contentMapId);
        setTheme(payload.theme);
        setIsChildForFormSubmit(true);
        setImgShow(true);
        if (
          +themeCount === ThemeNo.ThemeOne &&
          isEmptyObject(data?.payload?.data?.style)
        ) {
          setSettingFormData({ ...imagesGalleryThemeOneReset });
          setBoxSection(false);
          setBackImageToggle(false);
          setIsBackgroundColor(false);
        } else if (
          +themeCount === ThemeNo.ThemeTwo &&
          isEmptyObject(data?.payload?.data?.style)
        ) {
          setSettingFormData({ ...imagesGalleryThemeTwoReset });
          setBoxSection(false);
          setBackImageToggle(false);
          setIsBackgroundColor(false);
        } else if (
          +themeCount === ThemeNo.ThemeThree &&
          isEmptyObject(data?.payload?.data?.style)
        ) {
          setSettingFormData({ ...imagesGalleryThemeOneReset });
          setBoxSection(false);
          setBackImageToggle(false);
          setIsBackgroundColor(false);
        } else if (
          +themeCount === ThemeNo.ThemeFour &&
          isEmptyObject(data?.payload?.data?.style)
        ) {
          setSettingFormData({ ...imagesGalleryThemeTwoReset });
          setBoxSection(false);
          setBackImageToggle(false);
          setIsBackgroundColor(false);
        } else {
          if (
            payload.style?.[".photo-gallery-section"]?.["width"] ||
            payload.style?.[".photo-gallery-section"]?.["margin"] ||
            payload.style?.[".photo-gallery-section"]?.["border-radius"] ||
            payload.style?.[".certificates-section"]?.["width"] ||
            payload.style?.[".certificates-section"]?.["margin"] ||
            payload.style?.[".certificates-section"]?.["border-radius"]
          ) {
            setBoxSection(true);
          }
          if (
            payload.style?.[".photo-gallery-section.bg-image"]?.[
            "background-image"
            ] ||
            payload.style?.[".certificates-section.bg-image"]?.[
            "background-image"
            ]
          ) {
            setBackImageToggle(true);
          }
          if (
            payload.style?.[".photo-gallery-section"]?.["background-color"] ||
            payload.style?.[".certificates-section"]?.["background-color"]
          ) {
            setIsBackgroundColor(true);
          }

          if (+payload?.theme === 1 || +payload?.theme === 3) {
            const getMenuBtnStyle = generateDynamicStylesSet(
              payload,
              ".photo-gallery-section"
            );
            let ThemeOneSetValue = ThemeOneStyleSet({
              style: payload.style,
              settingFormData,
            });
            setSettingFormData((prev) => {
              return {
                ...ThemeOneSetValue,
                ...getMenuBtnStyle,
                custom: payload?.style?.custom,
                parentId: payload?.parentId,
              };
            });
          } else if (+payload?.theme === 2 || +payload?.theme === 4) {
            const getMenuBtnStyle = generateDynamicStylesSet(
              payload,
              ".certificates-section"
            );
            let ThemeTwoSetValue = ThemeTwoStyleSet({
              style: payload.style,
              settingFormData,
            });
            setSettingFormData((prev) => {
              return {
                ...ThemeTwoSetValue,
                ...getMenuBtnStyle,
                parentId: payload?.parentId,
                custom: payload?.style?.custom,
              };
            });
          }
        }
        if (!isThemeEdit) {
          OpenModalCommonFunc(
            Cases.SETTING_IMAGE_MULTI_PAGE_PARENT,
            setAllPopupState
          );
          TostMessage({ message: data, type: "success" });
        }
        setIsEdit(true);
        setLoaderShow(false);
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
      setLoaderShow(false);
    }
  };

  /**
   * delete images
   * @param {id} teamId
   */
  const handleDelete = async (
    teamId,
    isParent = false,
    isLastChild = false
  ) => {
    let conformation = window.confirm(DELETE_CONFIRM);
    try {
      if (conformation) {
        setLoaderShow(true);
        const { data } = await deleteImagesParent(teamId);
        if (data.status === 200) {
          if (isParent && isParent !== false) {
            ByteMiniWeb_Dashboard();
          } else {
            getImagesParentList({ isChild: true, isLastChild });
          }
          TostMessage({ message: data, type: "success" });
          setLoaderShow(false);
        }
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
      setLoaderShow(false);
    }
  };

  /**
   * clear data
   */
  const emptyData = () => {
    // setCollId("");
    if (!id) {
      // setChildId("");
      // setIdCopy("");
      // setIds("");
    }
    setIdCopy("");
    setIds("");
    // setChildData([]);
    setIsBackgroundColor(false);
    setBackImageToggle(false);
    setBoxSection(false);
    setIsEdit(false);
    setFormData({
      title: "",
      path: "",
      link: "",
      imageAlt: "",
      image: "",
      isTitleShow: true,
      webId: localStorage.getItem("webId"),
    });
    setSkill([{ id: randomStr(2), skill: "", parentageOfSkill: "" }]);
    setGalleryImgId("");
    setParentData([]);
    setFormDataImageParent({
      title: "",
      subTitle: "",
      buttonText: "",
      itemLimit: "",
      description: "",
      isAlbum: false,
      isTitleShow: true,
      theme: 1,
      navMapId: "",
      slugUrl: "",
      style: {
        ".photo-gallery-section": {
          padding: "100px 0",
          "background-color": "rgb(255 255 255 / 100)",
        },
        ".photo-gallery-section.bg-image": {
          "background-image": "",
        },
        ".photo-gallery-section.bg-image::before": {
          "background-color": "",
        },
        ".photo-gallery-section .section-title-area": {
          "margin-bottom": "50px",
        },
        ".photo-gallery-section .section-title-area .section-subtitle": {
          "font-size": "16px",
          "font-weight": "600",
          color: "rgb(255 73 124 / 100)",
          "background-color": "rgb(255 73 124 / 20%)",
          padding: "5px 20px",
          "border-radius": "15px",
          "margin-bottom": "15px",
        },
        ".photo-gallery-section .section-title-area .section-title": {
          "font-size": "44px",
          "font-weight": "600",
          color: "rgb(0 0 0 / 100)",
        },
        ".photo-gallery-section .gallery-catlist": {
          "text-align": "center",
          "margin-bottom": "30px",
        },
        ".photo-gallery-section .gallery-catlist .btn": {
          border: "2px solid rgb(255 73 124 / 100)",
          color: "rgb(255 73 124 / 100)",
          padding: "6px 20px",
          margin: "5px",
          "box-shadow": "none",
        },
        ".photo-gallery-section .gallery-catlist .active": {
          "background-color": "rgb(255 73 124 / 100)",
          color: "rgb(255 255 255 / 100)",
        },
        ".photo-gallery-section .gallery-catdata .box": {
          "margin-bottom": "15px",
          outline: "none",
          "background-color": "rgb(255 255 255 / 100)",
          "box-shadow": "0 5px 10px 0 rgba(7, 28, 31, 0.1)",
          "border-radius": "0px",
        },
        ".photo-gallery-section .gallery-catdata .gallery-img::before": {
          "font-family": "FontAwesome",
          color: "rgb(255 255 255 / 100)",
          "font-size": "30px",
        },
        ".photo-gallery-section .gallery-catdata .box:hover .gallery-img::before":
        {
          opacity: "1",
        },
        ".photo-gallery-section .gallery-catdata .gallery-img .title-text": {
          "background-color": "rgb(255 73 124 / 100)",
          "font-size": "16px",
          "font-weight": "600",
          color: "rgb(255 255 255 / 100)",
          "text-align": "center",
          padding: "14px",
        },
        ".photo-gallery-section .more-btn": {
          color: "rgb(255 255 255 / 100)",
          "font-size": "16px",
          "font-weight": "normal",
          "border-radius": "15px",
          padding: "5px 20px",
          "background-color": "rgb(255 73 124 / 100)",
        },
        ".photo-gallery-section .more-btn:hover": {
          "background-color": "rgb(255 73 124 / 100)",
          color: "rgb(255 255 255 / 100)",
        },
        ".pagination-positions": {
          "justify-content": "center",
        },
        ".pagination .page-link": {
          color: "rgb(255 73 124 / 100)",
        },
        ".pagination .page-item.active .page-link": {
          "background-color": "rgb(255 73 124 / 100)",
          "border-color": "rgb(255 73 124 / 100)",
        },
        showItem: 4,
      },
    });
    setLoaderShow(false);
    setSettingFormData({
      ".photo-gallery-section": {
        padding: "100px 0",
        "background-color": "rgb(255 255 255 / 100)",
      },
      image: "",
      ".photo-gallery-section.bg-image": {
        "background-image": "",
      },
      ".photo-gallery-section.bg-image::before": {
        "background-color": "",
      },
      ".photo-gallery-section .section-title-area": {
        "margin-bottom": "50px",
      },
      ".photo-gallery-section .section-title-area .section-subtitle": {
        "font-size": "16px",
        "font-weight": "600",
        color: "rgb(255 73 124 / 100)",
        "background-color": "rgb(255 73 124 / 20%)",
        padding: "5px 20px",
        p1: "5px",
        p2: "20px",
        "border-radius": "15px",
        "margin-bottom": "15px",
      },
      ".photo-gallery-section .section-title-area .section-title": {
        "font-size": "44px",
        "font-weight": "600",
        color: "rgb(0 0 0 / 100)",
      },
      ".photo-gallery-section .gallery-catlist": {
        "text-align": "center",
        "margin-bottom": "30px",
      },
      ".photo-gallery-section .gallery-catlist .btn": {
        border: "2px solid rgb(255 73 124 / 100)",
        borderPx: "2px",
        borderThik: "solid",
        borderColor: "rgb(255 73 124 / 100)",
        color: "rgb(255 73 124 / 100)",
        padding: "6px 20px",
        p1: "6px",
        p2: "20px",
        margin: "5px",
        "box-shadow": "none",
      },
      ".photo-gallery-section .gallery-catlist .active": {
        "background-color": "rgb(255 73 124 / 100)",
        color: "rgb(255 255 255 / 100)",
      },
      ".photo-gallery-section .gallery-catdata .box": {
        "margin-bottom": "15px",
        outline: "none",
        "background-color": "rgb(255 255 255 / 100)",
        "box-shadow": "0 5px 10px 0 #071C1A1A",
        bs1: "0px",
        bs2: "5px",
        bs3: "10px",
        bs4: "0px",
        shadowColor: "#071C1A1A",
        "border-radius": "0px",
      },
      ".photo-gallery-section .gallery-catdata .gallery-img::before": {
        "font-family": "FontAwesome",
        color: "rgb(255 255 255 / 100)",
        "font-size": "30px",
      },
      ".photo-gallery-section .gallery-catdata .box:hover .gallery-img::before":
      {
        opacity: "1",
      },
      ".photo-gallery-section .gallery-catdata .gallery-img .title-text": {
        "background-color": "rgb(255 73 124 / 100)",
        "font-size": "16px",
        "font-weight": "600",
        color: "rgb(255 255 255 / 100)",
        "text-align": "center",
        padding: "14px",
      },
      ".photo-gallery-section .more-btn": {
        color: "rgb(255 255 255 / 100)",
        "font-size": "16px",
        "font-weight": "normal",
        "border-radius": "15px",
        padding: "5px 20px",
        "background-color": "rgb(255 73 124 / 100)",
      },
      ".photo-gallery-section .more-btn:hover": {
        "background-color": "rgb(255 73 124 / 100)",
        color: "rgb(255 255 255 / 100)",
      },
      ".pagination-positions": {
        "justify-content": "center",
      },
      ".pagination .page-link": {
        color: "rgb(255 73 124 / 100)",
      },
      ".pagination .page-item.active .page-link": {
        "background-color": "rgb(255 73 124 / 100)",
        "border-color": "rgb(255 73 124 / 100)",
      },
      showItem: 4,
      galleryImgId: "",
    });
    setIsChildForFormSubmit(false);
  };

  const handleAlignAndCloneSection = ({ isClone = false }) => {
    if (isClone) {
      setCloneAlignModal((prev) => {
        return {
          ...prev,
          cloneModal: true,
        };
      });
      setCloneFormData((prev) => {
        return {
          ...prev,
          contentMapId,
          pageConfigDetailsLabel: pageConfigDetails[0]?.label,
          contentDetailName: contentDetail.name,
        };
      });
    } else {
      setCloneAlignModal((prev) => {
        return {
          ...prev,
          alignModal: true,
        };
      });
      setAlignFormData((prev) => {
        return {
          ...prev,
          contentMapId,
          label: pageConfigDetails[0]?.label,
        };
      });
    }
  };

  const handleBoy = (galleryId, title, theme) => {
    setTheme(theme);
    setSectionPageName(title);
    setChildData([]);
    OpenModalCommonFunc(Cases.IMAGES_CHILES, setAllPopupState);
    setChildId(galleryId);
  };
  return (
    <>
      <Col xl="12 box-col-6" md="12">
        <Card className="ecommerce-widget mt-4 cardHover">
          <CardBody
            className="support-ticket-font box-border-div"
            style={{ padding: "20px" }}
          >
            <Row>
              <CardBuilderHeaderSection
                addBtnTitle={pageConfigDetails[0]?.label}
                name={pageConfigDetails[0]?.label}
                isAdd={!galleryDetail && true}
                mainEditSection={true}
                ByteMiniWeb_Dashboard={ByteMiniWeb_Dashboard}
                pageId={pageConfigDetails[0]?.pageId}
                openModal={() => {
                  OpenModalCommonFunc(Cases.IMAGES_PARENT, setAllPopupState);
                  setSectionPageName(modalsName.IMAGES_PARENT);
                  setCollId(contentMapId);
                  emptyData();
                }}
              />
              {galleryDetail && (
                <Col xl="12 xl-50 box-col-6" md="6">
                  <Card className="ecommerce-widget mb-0">
                    <CardBody
                      className="support-ticket-font"
                      style={{ padding: "20px" }}
                    >
                      <div className="col-12">
                        <CardBuilderHeaderSection
                          name={galleryDetail?.title}
                          checked={galleryDetail?.isActive}
                          switchToggle={true}
                          isAdd={true}
                          id={galleryDetail?.galleryId}
                          openModal={() => {
                            OpenModalCommonFunc(
                              Cases.IMAGES_PARENT,
                              setAllPopupState
                            );
                            setCollId(contentMapId);
                            setIsImageParent(true);
                            setFormDataImageParent((prev) => {
                              return {
                                ...prev,
                                parentId: galleryDetail.galleryId,
                              };
                            });
                          }}
                          handleChange={handleChangeImageParent}
                          isCloneSection={true}
                          isAlignSection={true}
                          handleAlignAndCloneSection={
                            handleAlignAndCloneSection
                          }
                        />
                      </div>
                      <div className="d-flex justify-content-end ">
                        <IconButton
                          edge="start"
                          color="inherit"
                          style={{ marginLeft: "5px" }}
                          onClick={() =>
                            handleBoy(
                              galleryDetail.galleryId,
                              galleryDetail.title,
                              galleryDetail.theme
                            )
                          }
                        >
                          <Boy />
                        </IconButton>
                        <IconButton
                          edge="start"
                          color="inherit"
                          style={{ marginLeft: "5px" }}
                          onClick={() =>
                            handleEditImagesParent(
                              galleryDetail.galleryId,
                              galleryDetail.parentId ? true : false
                            )
                          }
                        >
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          edge="start"
                          color="inherit"
                          style={{ marginLeft: "5px" }}
                          onClick={() =>
                            handleDelete(galleryDetail.galleryId, true)
                          }
                        >
                          <Trash />
                        </IconButton>
                        <IconButton
                          edge="start"
                          color="inherit"
                          style={{ marginLeft: "5px" }}
                          onClick={() => {
                            handleChangeSettings(galleryDetail.galleryId);
                          }}
                        >
                          <Settings />
                        </IconButton>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              )}
              <DeleteSection
                ByteMiniWeb_Dashboard={ByteMiniWeb_Dashboard}
                pageId={pageConfigDetails[0]?.pageId}
              />
            </Row>
          </CardBody>
        </Card>
      </Col>
      <CommonPopup
        open={allPopupState.imagesPopup}
        close={() => OpenModalCommonFunc(Cases.IMAGES, setAllPopupState, false)}
        modalName={modalsName.IMAGES}
        modalCase={Cases.IMAGES}
        handleSubmit={handleSubmit}
        emptyData={emptyData}
        inputData={fromData}
        edit={true}
        oldTitle={titleUpdateKey.isGallery}
        label={titleUpdateKey.Certificates}
        getData={getData}
        content={
          <ImagesMultipagePopup
            handleChangeStatus={handleChangeStatus}
            getData={getImagesList}
            handleEdit={handleEdit}
            imageUpload={imageUploadImagess}
            emptyData={emptyData}
            simpleValidator={simpleValidatorImages}
            webMasterDetail={webMasterDetail}
          />
        }
      />

      {/* images parent popup */}
      <CommonPopup
        open={allPopupState.imagesParentPopup}
        close={() =>
          OpenModalCommonFunc(Cases.IMAGES_PARENT, setAllPopupState, false)
        }
        modalName={sectionPageName ? sectionPageName : modalsName.IMAGES_PARENT}
        modalCase={Cases.IMAGES_PARENT}
        handleSubmit={handleSubmitImages}
        validationForm={"parentForm"}
        emptyData={emptyData}
        inputData={formDataImageParent}
        edit={false}
        content={
          <ImagesMultipageParentPopup
            simpleValidator={parentValidator}
            galleryDetail={galleryDetail}
          />
        }
      />

      {allPopupState.imagesChildPopup && (
        <CommonPopup
          open={allPopupState.imagesChildPopup}
          close={() => {
            OpenModalCommonFunc(Cases.IMAGES_CHILES, setAllPopupState, false);
          }}
          modalName={
            sectionPageName ? sectionPageName : modalsName.IMAGES_CHILES
          }
          modalCase={Cases.IMAGES_CHILES}
          handleSubmit={handleSubmitImages}
          validationForm={"childForm"}
          emptyData={emptyData}
          inputData={formDataImageParent}
          edit={false}
          content={
            <ChildShow
              handleChangeImageParent={handleChangeImageParent}
              handleEditImagesParent={handleEditImagesParent}
              EditIcon={EditIcon}
              handleDelete={handleDelete}
              handleChangeSettings={handleChangeSettings}
              simpleValidator={childValidator}
              childId={childId}
              contentMapId={contentMapId}
              emptyData={emptyData}
              getImagesParentList={getImagesParentList}
              childData={childData}
              setChildData={setChildData}
              ids={ids}
              setIds={setIds}
              CountUp={CountUp}
              setCountUp={setCountUp}
              setIdCopy={setIdCopy}
              isBack={isBack}
            />
          }
        />
      )}

      {/* setting images parent popup */}
      <CommonPopup
        open={allPopupState.imageMultiPageSettingPopup}
        close={() =>
          OpenModalCommonFunc(
            Cases.SETTING_IMAGE_MULTI_PAGE_PARENT,
            setAllPopupState,
            false
          )
        }
        modalName={
          sectionPageName ? sectionPageName : modalsName.SETTING_STEPS_PARENT
        }
        modalCase={Cases.SETTING_IMAGE_MULTI_PAGE_PARENT}
        handleSubmit={handleSubmitSetting}
        emptyData={emptyData}
        inputData={formDataImageParent}
        edit={false}
        content={
          <SettingImageParentPopup
            simpleValidator={simpleValidator}
            imageUpload={imageUploadImages}
            handleSubmitSetting={handleSubmitSetting}
            handleChangeSettings={handleChangeSettings}
          />
        }
      />
    </>
  );
};

export default ImagesMultipage;
